import React from "react";
import "./FloatingButton.css";

/**
 * Minimalist FloatingButton with just the scrollTop method
 *  scrollToTop={true} is independet of the onclick function, and acrolls to top.
 */


const FloatingButton = ({ 
  onClick, 
  icon: Icon, 
  color = "31, 181, 163",
  ariaLabel,
  className = "",
  scrollToTop = false
}) => {
  const handleScrollToTop = () => {
    // Only use the scrollTop approach on document.documentElement and document.body
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    
    // Also try the main content container if it exists
    const mainContent = document.querySelector('main') || 
                         document.querySelector('.training-page') || 
                         document.querySelector('.training-creation-workflow');
    
    if (mainContent) {
      mainContent.scrollTop = 0;
    }
  };

  const handleClick = (e) => {
    if (scrollToTop) {
      handleScrollToTop();
    }
    
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <button 
      className={`floating-button ${className}`}
      onClick={handleClick}
      aria-label={ariaLabel || (scrollToTop ? "Scroll to top of page" : "Floating action button")}
      style={{ 
        backgroundColor: `rgb(${color})`,
        "--hover-color": `rgb(${color
          .split(",")
          .map(c => Math.max(0, parseInt(c.trim()) - 25))
          .join(", ")})`
      }}
    >
      {Icon && <Icon size={24} />}
    </button>
  );
};

export default FloatingButton;